// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2-3vf","footer":"ModalFilter_footer__KMVAS"};